export function getClassName(...args) {
  let className = '';
  for (let i = 0; i < args.length; i++) {
    if (args[i]) {
      if (typeof args[i] === 'string' || typeof args[i] === 'number') {
        className += ` ${args[i]}`;
      } else if (typeof args[i] === 'object') {
        // eslint-disable-next-line no-loop-func
        const argKeys = Object.keys(args[i]);
        for (let j = 0; j < argKeys.length; j++) {
          if (args[i][argKeys[j]]) {
            className += ` ${argKeys[j]}`;
          }
        }
      }
    }
  }
  return className.trim();
}
